<template>
      <a-col>
        <a-input type="textarea" class="provisioning_agree_container" :defaultValue="termsContent" disabled/>
      </a-col>
</template>

<script>
    export default {
        props: {
        msg: String
        },
        data() {
        return {
            termsContent: `本同意書說明興聯科技公司（以下簡稱興聯）將如何處理本表單所蒐集到的個人資料。當您勾選「我同意」並簽署本同意書時，表示您已閱讀、瞭解並同意接受本同意書之所有內容及其後修改變更規定。
                        \n若您未滿二十歲，應於您的法定代理人閱讀、瞭解並同意本同意書之所有內容及其後修改變更規定後，方得使用本服務，但若您已接受本服務，視為您已取得法定代理人之同意，並遵守以下所有規範。\n
    一、基本資料之蒐集、更新及保管
    1.興聯蒐集您的個人資料在中華民國「個人資料保護法」與相關法令之規範下，依據興聯【隱私權政策聲明】，蒐集、處理及利用您的個人資料。
    2.請於申請時提供您本人正確、最新及完整的個人資料。
    3.興聯因執行業務所蒐集您的個人資料包括姓名、電話、傳真、電子信箱、地址等。
    4.若您的個人資料有任何異動，請主動向興聯申請更正，使其保持正確、最新及完整。
    5.若您提供錯誤、不實、過時或不完整或具誤導性的資料，您將損失相關權益。
    6.您可依中華民國「個人資料保護法」，就您的個人資料行使以下權利：
    (1)請求查詢或閱覽。
    (2)製給複製本。
    (3)請求補充或更正。
    (4)請求停止蒐集、處理及利用。
    (5)請求刪除。`,
        }
        },
    }
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/global.scss";

  .provisioning_agree_container {
    height: 273px;
    overflow-y: auto;
    padding: 10px;
    resize: none;
  }
</style>